"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.download = exports.redirect = exports.withResponseHeaders = exports.binary = exports.csv = exports.text = exports.html = exports.empty = exports.noContent = exports.NO_CONTENT_STATUS = exports.ProviderMetadata = exports.EmptyData = exports.Empty = exports.Paginated = exports.Success = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const Json = __importStar(require("../../../json"));
const Protocol = __importStar(require("../v2/protocol"));
const Annotations = __importStar(require("./annotations"));
exports.NAMESPACE = 'Culligan.Api.OpenApi.Response';
/*
 * JSON envelopes: the legacy protocol wraps every JSON body in
 * `{ success: true, data }` (or `{ success: true }` when there is nothing to
 * return). These are the typed v2 helpers, re-exported under the names the
 * conventions document uses.
 */
/** `{ success: true, data: T }` */
exports.Success = Protocol.responseBodySuccess;
/** `{ success: true, data: { items, page, ... } }` */
exports.Paginated = Protocol.paginatedResponseBodySuccess;
/** `{ success: true }` */
exports.Empty = Protocol.ResponseBodyEmpty;
/** `{ success: true, data: {} }` — v1 `buildSuccessResponse()` without data */
exports.EmptyData = (0, exports.Success)(effect_1.Schema.Struct({}).annotations({
    identifier: `${exports.NAMESPACE}.EmptyObject`,
    jsonSchema: { type: 'object', additionalProperties: false, properties: {} },
})).annotations({
    identifier: `${exports.NAMESPACE}.EmptyData`,
});
/** Internal database engine metadata (raw Cosmos DB response). Not part of the contract; do not rely on it. */
exports.ProviderMetadata = Json.Record.annotations({
    identifier: `${exports.NAMESPACE}.ProviderMetadata`,
    description: 'Internal database engine metadata (raw Cosmos DB response). Not part of the contract; do not rely on it.',
});
/*
 * Non-JSON bodies. `RestApiEndpoint.sendResponse` answers `html`, `text` and
 * `stream` results with the matching content type; these describe them.
 *
 * They are factories rather than constants: the encoded side of a `Void` or
 * `Uint8Array` schema is not JSON, which the domain-wide schema sweep in
 * `src/index.test.ts` requires of every exported schema constant.
 */
exports.NO_CONTENT_STATUS = 204;
/** A bodiless 204 response (`buildDeletedResponse`, PassKit list/unregister, ...). */
const noContent = () => platform_1.HttpApiSchema.NoContent;
exports.noContent = noContent;
/** A bodiless response with an arbitrary status (e.g. 202 or 205). */
const empty = (status) => platform_1.HttpApiSchema.Empty(status);
exports.empty = empty;
/** `text/html` body (Swagger UI pages). */
const html = () => platform_1.HttpApiSchema.Text({ contentType: 'text/html' });
exports.html = html;
/** `text/plain` body. */
const text = () => platform_1.HttpApiSchema.Text({ contentType: 'text/plain' });
exports.text = text;
/** `text/csv` body (fleet exports). */
const csv = () => platform_1.HttpApiSchema.Text({ contentType: 'text/csv; charset=utf-8' });
exports.csv = csv;
/** Raw bytes with the given content type (defaults to `application/octet-stream`). */
const binary = (contentType = 'application/octet-stream') => platform_1.HttpApiSchema.Uint8Array({ contentType });
exports.binary = binary;
/**
 * Documents response headers for one status.
 *
 * `HttpApiEndpoint` only models request headers; response headers are added to
 * the generated operation instead.
 */
const withResponseHeaders = (status, headers) => Annotations.transformOperation(operation => {
    const responses = asRecord(operation['responses']);
    const response = asRecord(responses[String(status)]);
    const existing = asRecord(response['headers']);
    return {
        ...operation,
        responses: {
            ...responses,
            [String(status)]: { ...response, headers: { ...existing, ...headers } },
        },
    };
});
exports.withResponseHeaders = withResponseHeaders;
/**
 * A bodiless redirect: `Empty(status)` success plus a documented `Location` header.
 *
 * `description` is prose explaining where the redirect leads (e.g. "The
 * current documentation URL"); the header carries the target only at runtime.
 */
const redirect = (status, description) => (endpoint) => (0, exports.withResponseHeaders)(status, {
    Location: {
        description,
        schema: { type: 'string', format: 'uri' },
        required: true,
    },
})(endpoint.addSuccess((0, exports.empty)(status)));
exports.redirect = redirect;
/**
 * A file download: binary body plus a documented `Content-Disposition` header.
 */
const download = (options = {}) => (endpoint) => {
    const filename = options.filename === undefined ? '' : `; filename="${options.filename}"`;
    return (0, exports.withResponseHeaders)(200, {
        'Content-Disposition': {
            description: `attachment${filename}`,
            schema: { type: 'string' },
            required: true,
        },
    })(endpoint.addSuccess((0, exports.binary)(options.contentType), { status: 200 }));
};
exports.download = download;
const asRecord = (value) => typeof value === 'object' && value !== null ? { ...value } : {};
//# sourceMappingURL=response.js.map